import axiosInstance from './axiosInstance';
import { ENDPOINTS } from './endpoints';
import { dedupe } from './dedupe';

// GET  /chicken/config   -> { success, data: { isActive, minBet, maxBet, difficulties } }
export const getChickenConfigApi = () => dedupe('chicken-config', () => axiosInstance.get(ENDPOINTS.CHICKEN_CONFIG));
// GET  /chicken/active   -> chal raha round (reload ke baad resume ke liye)
export const getChickenActiveApi = () => dedupe('chicken-active', () => axiosInstance.get(ENDPOINTS.CHICKEN_ACTIVE));
// POST /chicken/start    body: { amount, difficulty }
export const startChickenApi = (data) => axiosInstance.post(ENDPOINTS.START, data);
// POST /chicken/step     body: { gameId, expectedStep }
export const stepChickenApi = (data) => axiosInstance.post(ENDPOINTS.STEP, data);
// POST /chicken/cashout  body: { gameId }
export const cashoutChickenApi = (data) => axiosInstance.post(ENDPOINTS.CASHOUT, data);
// GET  /chicken/history  -> data: [ { gameId, difficulty, betAmount, status, steps, cashoutMultiplier, winAmount, createdAt } ]
export const getChickenHistoryApi = () => dedupe('chicken-history', () => axiosInstance.get(ENDPOINTS.HISTORY));
